//GETTER
import mGetter from './mixins/getters.js'
Vue.use(mGetter)

//CSS.css
import './assets/css/css_style.css'
import './assets/css/css_backBox.css'
//CSS.vue
import './assets/css/css_titleSubTitle.vue'
import './assets/css/css_text.vue'
import './assets/css/css_separator.vue'
import './assets/css/css_container.vue'
import './assets/css/allSize.vue'

import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import Langue from './plugins/langue.js'
import formatMontant from './plugins/formatMontant.js'
import fctGeneral from './plugins/fctGeneral.js'
import fctKey from './plugins/fctKey.js'
import screenSize from './plugins/screenSize.js'
import taxes from './plugins/taxes.js'
import moment from 'moment';
//import VueColumnsResizable from '../plugins/vue-columns-resizable';
import VueColumnsResizable from '../node_modules/vue-columns-resizable';
import VueI18n from 'vue-i18n' // Import de vue-i18n
import pluginAccount from './plugins/pluginAccount.js'


import AwesomeMask from 'awesome-mask'
import directives from './plugins/directives.js'

Vue.prototype.moment = moment

Vue.use(Langue)
Vue.use(formatMontant)
Vue.use(fctGeneral)
Vue.use(fctKey)
Vue.use(screenSize)
Vue.use(taxes)
Vue.use(VueColumnsResizable);
Vue.use(VueI18n); // Utilisation de VueI18n dans Vue
Vue.use(pluginAccount)
Vue.use(directives)

Vue.directive('mask', AwesomeMask);

//BOOTSTRAP
import { BootstrapVue, BootstrapVueIcons, IconsPlugin} from 'bootstrap-vue'
//import { faCoffee } from '@fortawesome/free-solid-svg-icons'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(IconsPlugin)
//Vue.use(faCoffee)


//Imprimer ------------------------------------------------
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}

Vue.use(VueHtmlToPaper, options);
// or using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
//FIN - Imprimer ------------------------------------------------

//*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-

//DÉCLARATION DES COMPONENTS GENERAL
import sMenuSave from './components/general/s-menuSave/s-menuSave.vue'
Vue.component('s-menuSave', sMenuSave)

import sNavSide from './components/general/s-navSide/s-navSide.vue'
Vue.component('s-navSide', sNavSide)
//FIN - DÉCLARATION DES COMPONENTS GENERAL

//DÉCLARATION DES COMPONENTS COMMUN
import sColorSelector from './components/communs/s-colorSelector/s-colorSelector.vue'
Vue.component('s-colorSelector', sColorSelector)

import sComboFix from './components/communs/s-comboFix/s-comboFix.vue'
Vue.component('s-comboFix', sComboFix)

import sComboSelector from './components/communs/s-comboSelector/s-comboSelector.vue'
Vue.component('s-comboSelector', sComboSelector)

import sCurrencyInput from './components/communs/s-currencyInput/s-currencyInput.vue'
Vue.component('s-currencyInput', sCurrencyInput)

import sDuoSelector from './components/communs/s-duoSelector/s-duoSelector.vue'
Vue.component('s-duoSelector', sDuoSelector)

import sItemList from './components/communs/s-itemList/s-itemList.vue'
Vue.component('s-itemList', sItemList)

import sLangueSelector from './components/communs/s-langueSelector/s-langueSelector.vue'
Vue.component('s-langueSelector', sLangueSelector)

import sLine from './components/communs/s-line/s-line.vue'
Vue.component('s-line', sLine)

import sSubElementSelector from './components/communs/s-subElementSelector/s-subElementSelector.vue'
Vue.component('s-subElementSelector', sSubElementSelector)

import sTabs from './components/communs/s-tabs/s-tabs.vue'
Vue.component('s-tabs', sTabs)

import sUpDownArrow from './components/communs/s-upDownArrow/s-upDownArrow.vue'
Vue.component('s-upDownArrow', sUpDownArrow)

import sPagination from './components/communs/s-pagination/s-pagination.vue'
Vue.component('s-pagination', sPagination)

import sButton from './components/communs/s-button/s-button.vue'
Vue.component('s-button', sButton)

import sConfirmationButton from './components/communs/s-button/s-confirmation-button.vue'
Vue.component('s-confirmation-button', sConfirmationButton)
//FIN - DÉCLARATION DES COMPONENTS COMMUN

//DÉCLARATION DES COMPONENTS SERVEX
import sinput from './components/servex/s-input/s-input.vue'
Vue.component('s-input', sinput)

import sinputcheck from './components/servex/s-inputCheck/s-inputCheck.vue'
Vue.component('s-input-check', sinputcheck)

import staxes from './components/servex/s-taxes/s-taxes.vue'
Vue.component('s-taxes', staxes)

import compteAutoComplete from './components/comptes/compteAutoComplete/compteAutoComplete.vue'
Vue.component('compteAutoComplete', compteAutoComplete)

import sdatePicker from './components/servex/s-datePicker/s-datePicker.vue'
Vue.component('s-datePicker', sdatePicker)

import smonthSelector from './components/servex/s-monthSelector/s-monthSelector.vue'
Vue.component('s-monthSelector', smonthSelector)

//FIN - DÉCLARATION DES COMPONENTS SERVEX

//*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-

// Création d'une instance i18n exportée pour être utilisée partout dans Vue
function loadLocaleMessages () {
  const locales = require.context('./langue', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

//Ajouter un bus de communication entre le parent et le component enfant
export const bus = new Vue()

export const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: loadLocaleMessages()
})

Vue.config.productionTip = true

new Vue({
  i18n,  
  router,
  store,
  VueHtmlToPaper,
  render: h => h(App),
}).$mount('#app')